import { Alert, Box, Button, Checkbox, CircularProgress, Divider, FormControlLabel, FormGroup, Paper, Stack, TextField, Typography } from "@mui/material";
import { useRef, useState, useEffect } from 'react' 
import { Link, useNavigate, useLocation } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import config from "../../common/Config";

function Login() {
	const {setAuth} 					= useAuth();

	const navigate						= useNavigate();
	const location						= useLocation();
	const from							= location.state?.from?.pathname || "/";

	const userRef 						= useRef();

	const [user, setUser] 				= useState('');
	const [pass, setPass]				= useState('');
	const [rememberMe, setRememberMe]	= useState(false);
	const [errorMsg, setErrorMsg] 		= useState('');
	const [btnMsg, setBtnMsg]			= useState('Login')
	const [btnDisabled, setBtnDisabled]	= useState(false)

	useEffect(() => {
		userRef.current.focus();
	}, [])

	const handleKeyPress = (event) => {
		if (event.keyCode === 13 || event.which === 13) handleLogin()
	}

	const handleLogin = () => {
		setBtnDisabled(true)
		setBtnMsg(<CircularProgress/>)

		let options = {
			method : 'POST',
			headers : { 
				'content-type' : 'application/json; charset=utf-8',
			},
			credentials : 'include',
			body : JSON.stringify({
				username 	: user,
				password	: pass,
				rememberMe 	: rememberMe
			})
		}

		fetch(config.apiUrl +'/auth', options)
		.then(results => results.json())
		.then(results => {

			if (results.status === 200) {
				const userId 		= results.data.userId
				const accessToken 	= results.data.accessToken

				setAuth({ userId, user, accessToken })
				
				setErrorMsg('')
				setUser('')
				setPass('')
				navigate(from, {replace : true});
			}
			else {
				switch (results.errorCode) {
					case 'INVALIDUSERORPASSWORD' :  setErrorMsg(<Typography>Usuário ou senha inválidos!</Typography>); break;
					case 'EMAILNOTVERIFIED' : setErrorMsg(<Typography>E-mail não verificado. Clique <Link to="/verify" reloadDocument>aqui</Link> para verificar.</Typography>); break;
					default : setErrorMsg(<Typography>Ocorreu um erro desconhecido. Tente novamente mais tarde.</Typography>); break;
 				}

				setBtnMsg('Login')
				setBtnDisabled(false)
			}
		})
		.catch(e => {
			setErrorMsg(<Typography>Servidor inacessível. Tente novamente mais tarde.</Typography>)
			setBtnMsg('Login')			
			setBtnDisabled(false)
		})
	}
	
	return (
		<Box
			sx={{
				height: "88vh",               // ocupa toda a altura da tela
				display: "flex",
				justifyContent: "center",      // centraliza horizontalmente
				alignItems: "center",          // centraliza verticalmente
				backgroundColor: "#f0f0f0",   // opcional
			}}
			>     
			<Paper sx={{minWidth:500, margin:'auto' }} elevation={2} >
				<Stack spacing={2} padding={10}>
					{(errorMsg !== '' ? <Alert severity="error">{errorMsg}</Alert> : null )}
					<TextField 
						name="username" 
						label="Username ou E-mail" 
						autoComplete="off" 
						inputRef={userRef}
						value={user} 
						onChange={(e) => setUser(e.target.value)}
						onKeyDown={handleKeyPress}
						required
						tabIndex={1}
					/>
					<TextField 
						name="password" 
						type="Password" 
						label="Password"
						onChange={(e) => setPass(e.target.value)} 
						onKeyDown={handleKeyPress}
						tabIndex={2}
					/>
					<FormGroup>
						<FormControlLabel 
							control={<Checkbox onChange={e => setRememberMe(e.target.checked ? true : false)} tabIndex={0}/>} 
							label={<Typography variant="subtitle2">Lembrar-me</Typography>}
						/>
					</FormGroup>
					<Button variant="contained" type="submit" onClick={handleLogin} disabled={btnDisabled} sx={{minHeight:'52px'}} tabIndex={0}>{btnMsg}</Button>
					<Link to="/recoverpassword" tabIndex={0}><Typography variant="subtitle2">Esqueci minha senha</Typography></Link>
					
					<Divider sx={{ my: 3 }}>
						<Typography variant="body2" color="text.secondary">Não possui uma conta?</Typography>
					</Divider>
					<Button component={Link} to="/register" variant="contained" sx={{minHeight:'52px'}} tabIndex={0}>Cadastre-se</Button>		

				</Stack>

			</Paper>
		</Box>
	)
}

export default Login